import { useMediaQuery } from '@mui/material';

const useFormat = () => {
	const isMobileFormat = useMediaQuery('(max-width:768px)', { noSsr: true });

	return { isMobileFormat };
};

export default useFormat;
